module.exports = __webpack_public_path__ + "img/513-42dfb3.png";